export enum FormAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}
